import React from 'react'

import { string, node } from 'prop-types'

function ValuePropositionCard({ icon = null, title, description }) {
  return (
    <div className="value-proposition__card">
      {icon || null}
      <div className="value-proposition__card--content">
        <h3 className="value-proposition__card--title">{title}</h3>
        <span className="cgt-legacy-text-default">{description}</span>
      </div>
    </div>
  )
}

ValuePropositionCard.propTypes = {
  icon: node,
  title: string.isRequired,
  description: string.isRequired,
}

export default ValuePropositionCard
